import { lazy } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

const DiscoverAccountsPayableViewChunk = lazy(() =>
  import('@webapp/modules/accounts-payable/feature-sets/DiscoverAccountsPayableView').then(
    ({ DiscoverAccountsPayableView }) => ({
      default: DiscoverAccountsPayableView,
    })
  )
)

export const DiscoverAccountsPayablePage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.discoverAccountsPayablePageTitle)}
      breadcrumbs={[]}
    >
      <DiscoverAccountsPayableViewChunk />
    </Page>
  )
}

DiscoverAccountsPayablePage.displayName = 'DiscoverAccountsPayablePage'
